var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergyEfficiency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      color: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11218 14.539V15.671C9.11218 16.3624 8.83751 17.0255 8.3486 17.5144C7.85969 18.0033 7.19661 18.278 6.50519 18.278H4.49219V11.939H6.50519C7.1954 11.939 7.85742 12.2127 8.34613 12.7001C8.83484 13.1875 9.11033 13.8488 9.11218 14.539V14.539Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 16.151V16.909C1.6001 16.962 1.62115 17.0129 1.65866 17.0504C1.69617 17.0879 1.74704 17.109 1.80008 17.109H4.50809V15.954H1.79709C1.74508 15.9548 1.69541 15.9758 1.65863 16.0125C1.62185 16.0493 1.60087 16.099 1.6001 16.151V16.151Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 13.285V14.04C1.6001 14.0931 1.62115 14.1439 1.65866 14.1814C1.69617 14.2189 1.74704 14.24 1.80008 14.24H4.50809V13.088H1.79709C1.74508 13.0888 1.69541 13.1098 1.65863 13.1466C1.62185 13.1833 1.60087 13.233 1.6001 13.285V13.285Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99725 13.97H9.84924C9.95913 13.97 10.0645 14.0136 10.1423 14.0912C10.2201 14.1688 10.264 14.2741 10.2643 14.384V15.858C10.264 15.9679 10.2201 16.0732 10.1423 16.1508C10.0645 16.2284 9.95913 16.272 9.84924 16.272H8.99023",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0728 6.85303L9.75882 9.15303C9.61482 10.718 10.5008 11.144 12.2128 11.144C12.4706 11.1442 12.7258 11.1952 12.9637 11.2942C13.2017 11.3933 13.4178 11.5383 13.5996 11.7211C13.7813 11.9039 13.9251 12.1208 14.0228 12.3593C14.1205 12.5978 14.1701 12.8533 14.1688 13.111L14.1618 13.175C14.1595 13.6925 13.9522 14.188 13.5855 14.553C13.2187 14.9181 12.7223 15.123 12.2048 15.123H10.2558",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3481 2.80803C16.4513 2.62998 15.5274 2.63887 14.6342 2.83417C13.7411 3.02946 12.8978 3.40696 12.1571 3.94303C7.98914 7.10503 10.6711 10.643 14.9031 7.43203C15.6007 6.86537 16.1768 6.16377 16.597 5.36925C17.0171 4.57473 17.2725 3.70361 17.3481 2.80803Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18425 1C5.09582 1.07029 5.98307 1.32787 6.79057 1.75665C7.59807 2.18544 8.30844 2.7762 8.87724 3.492C12.0392 7.66 8.50226 10.343 5.29326 6.111C4.77418 5.37745 4.4084 4.54671 4.21785 3.66852C4.02729 2.79032 4.01587 1.88272 4.18425 1V1Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyEfficiency);
export default __webpack_public_path__ + "static/media/energy-efficiency.755861415787e0e8392c8c292a8f116e.svg";
export { ForwardRef as ReactComponent };